import * as React from 'react';
import { Flex, FlexDirection } from 'src/components/Flex/Flex';
import styled from 'styled-components';
import ReactTable, { Column } from 'react-table';
import 'src/ReactTableStyles.css';
import 'react-table/react-table.css';
import { H3 } from 'src/components/Elements/Elements';
import { AppConsumer } from '../../contexts/Context';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactSelect, { Option } from 'react-select';
import { ErrorMessages, Color, DEFAULT_PAGE_SIZE } from '../Globals/Globals';
import * as moment from 'moment';

const OfferingTableWrapper = styled(Flex)`
  width: 100%;
`;

const StyledReactTable = styled(ReactTable)`
  width: 100%;
  line-height: 2em;
`;

const NewTag = styled.span`
  display: inline-block;
  background: ${Color.orange};
  color: ${Color.white};
  line-height: 18px;
  font-size: 0.7em;
  font-weight: 600;
  padding: 0 0.7em;
  border-radius: 0.3em;
  margin-left: 1em;
`;

interface IOfferingLinkProps {
  isNew?: boolean;
}

const OfferingLink = styled(Link)<IOfferingLinkProps>`
  max-width: ${props => (props.isNew ? `calc(100% - 3em);` : `100%`)};
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: bottom;
`;

const TableColumn = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
`;

interface IOfferingTableState {
  selectedPageSize: number | undefined;
  pageSizes: Option[];
}

export class OfferingTable extends React.Component<{}, IOfferingTableState> {
  private initialPageSize: number = DEFAULT_PAGE_SIZE;
  private pageSizes: Option[] = [
    { label: 'Show 10', value: 10 },
    { label: 'Show 15', value: 15 },
    { label: 'Show 25', value: 25 },
    { label: 'Show 50', value: 50 }
  ];

  constructor(props: any) {
    super(props);
    this.state = {
      selectedPageSize: this.initialPageSize,
      pageSizes: this.pageSizes
    };
  }

  public renderColumnWithLink(data: any) {
    const isNew = this.isNew(moment(data.original.releaseDate).toDate());
    return (
      <div>
        <OfferingLink isNew={isNew} to={'/offering/' + data.original.id}>
          {data.value}
        </OfferingLink>
        {isNew && <NewTag>new</NewTag>}
      </div>
    );
  }

  public isNew(date: Date): boolean {
    const yearInMilliseconds = 365 * 24 * 60 * 60 * 1000;
    const quarterYear = yearInMilliseconds / 4;
    return new Date().getTime() - date.getTime() < quarterYear;
  }

  public renderTableHeader(text: string) {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        {text}
        <FontAwesomeIcon icon="sort" />
      </div>
    );
  }

  public render() {
    const columns: Column[] = [
      {
        Header: (data, column) => this.renderTableHeader('Solution name'),
        accessor: 'solutionName',
        Cell: row => this.renderColumnWithLink(row),
        width: 300
      },
      {
        Header: (data, column) => this.renderTableHeader('Offering type'),
        accessor: 'offeringType'
      },
      {
        Header: (data, column) => this.renderTableHeader('Industry'),
        accessor: 'industry',
        Cell: row => {
          return (
            <TableColumn title={row && row.value.join(', ')}>
              {row && row.value.join(', ')}
            </TableColumn>
          );
        }
      },
      {
        Header: (data, column) => this.renderTableHeader('Business line'),
        accessor: 'businessLine',
        Cell: row => {
          return (
            <TableColumn title={row && row.value.join(', ')}>
              {row && row.value.join(', ')}
            </TableColumn>
          );
        }
      },
      {
        Header: (data, column) => this.renderTableHeader('Products'),
        accessor: 'applicableProducts',
        Cell: row => {
          return (
            <TableColumn title={row && row.value.join(', ')}>
              {row && row.value.join(', ')}
            </TableColumn>
          );
        }
      }
    ];

    return (
      <AppConsumer>
        {({ state }) => (
          <OfferingTableWrapper direction={FlexDirection.column}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <H3>{state.filteredSolutions.length} results</H3>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <ReactSelect
                  searchable={false}
                  clearable={false}
                  options={this.pageSizes}
                  value={this.state.selectedPageSize}
                  style={{ width: 100 }}
                  onChange={(option: Option<number>) =>
                    this.setState({ selectedPageSize: option.value })
                  }
                />
              </div>
            </div>
            <StyledReactTable
              data={state.filteredSolutions}
              columns={columns}
              defaultPageSize={12}
              pageSize={this.state.selectedPageSize}
              className="-striped -highlight"
              noDataText={ErrorMessages.noSolutions}
              showPageSizeOptions={false}
              showPageJump={false}
            />
          </OfferingTableWrapper>
        )}
      </AppConsumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OfferingTable/OfferingTable.tsx